import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { writeSignup } from "./signupState";
import { accountTypeForRole } from "./accountTypes";

// /register/other was the classic sign-up form, retired now that every
// account type signs up on the V2 steps. An old link still opens the type
// screen, with its ?role= type already picked.
const ClassicRegisterRedirect = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  useEffect(() => {
    const accountType = accountTypeForRole(params.get("role"));
    if (accountType) writeSignup({ accountType });
    navigate("/register", { replace: true });
  }, [params, navigate]);
  return null;
};

export default ClassicRegisterRedirect;
